<template>
  <section class="content">
    <div>
      <!--版本下拉列表-->
      <div id="version-list-popmenu" class="btn-group version-manage-dropdown-btn">
        <button
          type="button"
          class="btn btn-default dropdown-toggle version-manage-dropdown"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <span class="pull-left">{{currentVersion.versionname}}</span>
          <span class="caret pull-right version-manage-dropdown-icon"></span>
        </button>
        <ul id="version-list-pop-menu" class="dropdown-menu version-manage-dropdown">
          <li data-target="#modal-new-version" v-on:click="toNewVersion">
            <a href="#" class="version-manage-dropdown-new">
              <i class="fa fa-plus"></i>New Version
            </a>
          </li>
          <li role="separator" class="divider"></li>
          <li v-for="(item,index) in versionList " :key="item.id">
            <a href="#" v-on:click="selectVersoin(index)">{{item.versionname}}</a>
          </li>
          <li role="separator" class="divider"></li>
          <li>
            <a
              class="version-manage-dropdown-more"
              v-on:click="toLoadMoreVersion(currentVersoinPage)"
            >
              More&nbsp;&nbsp;&nbsp;
              <i class="fa fa-angle-double-right"></i>
            </a>
          </li>
        </ul>
      </div>
      <!--版本下拉列表-->
      <div class="version-manage-content" v-show="versionList.length>0">
        <!--阶段-->
        <div class="row">
          <div
            class="col-lg-4 col-md-4 col-sm-12 col-xs-12 version-manage-stage-margin"
            v-for="item in currentVersion.GeneralSetting.StageSupport"
          >
            <div :class="getStageClassByTypeId(item)">
              <div class="box-header with-border">
                <span class="box-title">{{getNameByTypeId(item)}}</span>
                <span :class="getStageLogClassByTypeId(item)" v-on:click="toShowLog(item)">Log</span>
              </div>
              <div class="box-body">
                <!--下拉列表-->
                <div class="btn-group version-manage-box-body-dropdown">
                  <div v-if="item !== 'S3'">
                    <button
                      type="button"
                      class="btn btn-default dropdown-toggle version-manage-dropdown version-manage-box-body-dropdown-btn"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span
                        class="pull-left"
                        v-if="currentStageBuild[item].buildnumber"
                      >build {{currentStageBuild[item].buildnumber}} ({{currentStageBuild[item].time/1000000 | formatDate}})</span>
                      <span class="pull-left" v-else>-</span>
                      <span class="caret pull-right version-manage-dropdown-icon"></span>
                    </button>
                    <ul
                      class="dropdown-menu version-manage-dropdown version-manage-box-body-dropdown-btn"
                    >
                      <li data-target="#modal-new-version" v-on:click="toNewBuild(item)">
                        <a href="#" class="version-manage-dropdown-new">
                          <i class="fa fa-plus"></i>New Build
                        </a>
                      </li>
                      <li role="separator" class="divider" v-show="isHasBuildList(item)"></li>
                      <li v-for="(b, index) in getBuildlistById(item)">
                        <a
                          v-on:click="selectBuild(item,index)"
                        >build {{b.buildnumber}} ({{b.time/1000000 | formatDate}})</a>
                      </li>
                      <li role="separator" class="divider" v-show="isHasBuildList(item)"></li>
                      <li>
                        <a
                          href="#"
                          class="version-manage-dropdown-more"
                          v-on:click="toLoadMoreBuild(item)"
                          v-show="isHasBuildList(item)"
                        >
                          More&nbsp;&nbsp;&nbsp;
                          <i class="fa fa-angle-double-right"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div v-else>
                    <button
                      type="button"
                      class="btn btn-default dropdown-toggle version-manage-dropdown version-manage-box-body-dropdown-btn"
                    >
                      <span
                        class="pull-left"
                        v-if="currentStageBuild[item].buildnumber"
                      >build {{currentStageBuild[item].buildnumber}} ({{currentStageBuild[item].time/1000000 | formatDate}})</span>
                      <span class="pull-left" v-else>-</span>
                    </button>
                  </div>
                </div>
                <!--下拉列表-->
                <!--comment-->
                <div class="version-manage-comment">
                  <div
                    :class="currentStageBuild[item].result ===1?'version-manage-build-state gone':'version-manage-build-state'"
                  >
                    <p>
                      <i :class="getBuildStageClassByTypeId(currentStageBuild[item].result)"></i>
                      <br>
                      {{getState(currentStageBuild[item].result)}}
                    </p>
                  </div>

                  <p
                    :class="emptyToInVisibiliy(currentStageBuild[item].comment,'version-manage-stage-comment')"
                  >{{currentStageBuild[item].comment}}</p>
                </div>
                <div class="version-manage-stage-more invisibiliy">
                  more&nbsp;&nbsp;&nbsp;
                  <i class="fa fa-angle-double-right"></i>
                </div>
                <!--comment-->
                <!--button-->
                <div class="version-manage-button">
                  <div class="version-manage-button" v-if="item !== 'S3'">
                    <button
                      type="button"
                      :class="emptyToInVisibiliy(currentBuildList[item].length>0,'btn btn-info')"
                      v-on:click="toShowShell(item)"
                    >查看SHELL配置</button>
                    <button
                      type="button"
                      :class="emptyToInVisibiliy(currentBuildList[item].length>0,'btn btn-info')"
                      v-on:click="toShowDownload(item)"
                    >Download App</button>
                    <button
                      type="button"
                      class="btn btn-info"
                      v-on:click="currentBuildList[item].length>0?
                  toSendDingDing(item):toNewBuild(item)"
                    >
                      {{currentBuildList[item].length>0?
                      '发送钉钉通知':'New Build'}}
                    </button>
                  </div>
                  <div class="version-manage-button" v-else>
                    <button
                      type="button"
                      :class="isPublishSelectSuccess(item,'btn btn-info')"
                      v-on:click="toShowShell(item)"
                    >查看SHELL配置</button>
                    <button
                      type="button"
                      :class="isPublishSelectSuccess(item,'btn btn-info')"
                      v-on:click="toDoPublishClick(item)"
                    >{{getBtnText(item)}}</button>
                    <button
                      type="button"
                      :class="isPublishSelectSuccess(item,'btn btn-info')"
                      v-on:click="toSendDingDing(item)"
                    >发送钉钉通知</button>
                  </div>
                </div>
                <!--button-->
              </div>
              <!-- /.box-body-->
            </div>
            <!-- /.box -->
          </div>
          <!-- /.col -->
        </div>

        <!--阶段-->
        <!--log-->
        <div class="version-manage-log">
          <div class="row">
            <div class="col-lg-12">
              <div class="box box-solid">
                <div class="box-header with-border">
                  <i class="fa fa-file-code-o"></i>
                  <span class="version-manage-log-title">Develop Log</span>
                  <button
                    type="button"
                    class="btn btn-info pull-right btn-device-user-list-setting"
                    v-on:click="toSaveLog"
                  >Save</button>
                </div>
                <div class="box-body">
                  <textarea
                    id="currentVersionDevelopLog"
                    class="form-control version-manage-log-textarea"
                    v-bind:value="currentVersion.developlog"
                    placeholder="Develop log..."
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <div class="box box-solid">
                <div class="box-header with-border">
                  <i class="fa fa-file-powerpoint-o"></i>
                  <span class="version-manage-log-title">Publish Log</span>
                  <button
                    type="button"
                    class="btn btn-info pull-right btn-device-user-list-setting"
                    v-on:click="toSaveLog"
                  >Save</button>
                </div>
                <div class="box-body">
                  <textarea
                    id="currentVersionReleaseLog"
                    class="form-control version-manage-log-textarea"
                    v-bind:value="currentVersion.releaselog"
                    placeholder="Publish log..."
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--log-->
        <!--删除当前版本-->
        <!--<div>-->
        <!--<button type="button" class="btn btn-danger dropup" data-toggle="dropdown">Delete this Version</button> -->
        <!--<ul class="dropdown-menu alert-del">-->
        <!--<li><i class="icon fa fa-warning alert-del-warning"></i>Confirm to delete?</li>-->
        <!--<li>-->
        <!--<button class="btn btn-default">Cancel</button>-->
        <!--<button class="btn btn-danger">Delete</button>-->
        <!--</li>-->
        <!--</ul>-->
        <!--</div>-->
        <!--删除当前版本-->
      </div>

      <!-- 空version -->
      <div v-show="versionList.length<=0">
        <p class="large_title">There's no version!</p>
        <div class="version-manage-new-version">
          <button type="button" class="btn btn-info" v-on:click="toNewVersion">
            <i class="fa fa-plus"></i>&nbsp;&nbsp;&nbsp;New Version
          </button>
        </div>
      </div>
    </div>

    <!--弹窗-->
    <!--modal-new-version-->
    <div class="modal fade in" id="modal-new-version">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">New Version</h4>
          </div>
          <div class="modal-body">
            <div class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-3 control-label agent-edit-modal-name">Version Number</label>
                <div class="col-sm-9 agent-edit-modal-name">
                  <input
                    class="form-control"
                    placeholder="version number"
                    v-model="newversion_name"
                  >
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label agent-edit-modal-name">Develop Log</label>
                <div class="col-sm-9 agent-edit-modal-name">
                  <textarea
                    class="form-control edit-information-textarea"
                    v-model="newversion_developlog"
                    placeholder="develop log..."
                  ></textarea>
                </div>
              </div>

              <div class="row modal-new-version-shell">
                <div class="col-xs-12">
                  <div class="box box-solid collapsed-box modal-new-version-shell-box">
                    <div class="box-header with-border">
                      <h3 class="box-title" style="font-size: 14px;">Shell Configuration</h3>
                      <div class="box-tools">
                        <button type="button" class="btn btn-box-tool" data-widget="collapse">
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>
                    </div>

                    <div class="box-body">
                      <div class="form-group">
                        <label class="col-sm-3 control-label agent-edit-modal-name">TEST</label>
                        <div class="col-sm-9 agent-edit-modal-name">
                          <textarea
                            class="form-control edit-information-textarea"
                            v-model="newversion_developshell"
                            placeholder="shell..."
                          ></textarea>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-3 control-label agent-edit-modal-name">API</label>
                        <div class="col-sm-9 agent-edit-modal-name">
                          <textarea
                            class="form-control edit-information-textarea"
                            v-model="newversion_releaseshell"
                            placeholder="shell..."
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
              aria-label="Cancel"
            >Cancel</button>
            <button type="button" class="btn btn-info" data-toggle="dropdown">New Version</button>
            <ul class="dropdown-menu alert-del pull-right">
              <li>
                <p>
                  <i class="icon fa fa-warning alert-del-warning"></i>
                  Please confirm that the datas below in
                  <strong>Shell Configuration</strong> are filled in correctly :
                </p>
                <p
                  class="security-state-dialog-status modal-dialog-new-version-confirm"
                >development branch</p>
                <p class="security-state-dialog-status">Application id</p>
                <p
                  class="security-state-dialog-status modal-dialog-new-version-confirm-down"
                >jPush key</p>
              </li>
              <li>
                <button class="btn btn-default pull-left">Not Sure</button>
                <button class="btn btn-danger pull-right" v-on:click="toDoNewVersion">Confirm</button>
              </li>
            </ul>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!--/ modal-new-version-->
    <!--modal-new-build-->
    <div class="modal fade in" id="modal-new-build">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">New Build</h4>
          </div>
          <div class="modal-body">
            <div class="form-horizontal">
              <div class="form-group">
                <div class="row" v-for="item in macRobotList" :key="item.id">
                  <div class="col-lg-1 col-md-1 col-sm-2 col-xs-2 modal-dialog-sendto-robotpick">
                    <input
                      class="modal-dialog-sendto-robotpick-input"
                      type="radio"
                      v-model="newbuild_robotid"
                      :value="item.id"
                    >
                  </div>

                  <div class="col-lg-2 col-md-2 col-sm-3 col-xs-3">
                    <img
                      class="device-user-list-portrait"
                      v-if="!item.icon"
                      src="../../../static/img/img_app_list_icon_default.png"
                    >
                    <img
                      class="device-user-list-portrait"
                      v-else
                      v-bind:src="'https://d.din.bz/'+item.icon"
                    >
                  </div>

                  <div class="col-lg-9 col-md-9 col-sm-7 col-xs-7 device-user-list-data">
                    <p class="device-user-list-username">{{item.name}}</p>
                    <div class="col-lg-2 col-md-3 col-sm-3 col-xs-4">
                      <span
                        class="robot-list-status label label-default"
                        v-if="item.isOnline == false"
                      >offline</span>
                      <span
                        class="robot-list-status label label-info"
                        v-else-if="item.task == 0"
                      >free</span>
                      <span
                        class="robot-list-status label label-warning"
                        v-else-if="item.task > 0"
                      >building</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label agent-edit-modal-name">Develop Log</label>
                <div class="col-sm-9 agent-edit-modal-name">
                  <textarea
                    class="form-control edit-information-textarea"
                    v-model="newbuild_developlog"
                    placeholder="develop log..."
                  ></textarea>
                </div>
              </div>

              <div class="row modal-new-version-shell">
                <div class="col-xs-12">
                  <div class="box box-solid collapsed-box modal-new-version-shell-box">
                    <div class="box-header with-border">
                      <h3 class="box-title" style="font-size: 14px;">Shell Configuration</h3>
                      <div class="box-tools">
                        <button type="button" class="btn btn-box-tool" data-widget="collapse">
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>
                    </div>

                    <div class="box-body">
                      <div class="form-group">
                        <label class="col-sm-3 control-label agent-edit-modal-name">Shell</label>
                        <div class="col-sm-9 agent-edit-modal-name">
                          <textarea
                            class="form-control edit-information-textarea"
                            v-model="newbuild_developshell"
                            placeholder="shell..."
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
              aria-label="Cancel"
            >Cancel</button>
            <button type="button" class="btn btn-info" v-on:click="toDoNewBuild">New Build</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!--/ modal-new-version-->
    <!-- shell 弹窗 -->
    <div class="modal fade in" id="modal-shell">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Shell</h4>
          </div>
          <div class="modal-body">
            <p class="modal-dialog-shell-p">{{shellDialogContent}}</p>
          </div>
          <div class="modal-footer">
            <!-- <button type="button" class="btn btn-default pull-left" data-dismiss="modal">关闭</button> -->
            <!-- <button type="button" class="btn btn-primary">保存修改</button> -->
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- shell 弹窗 -->
    <!-- download 弹窗 -->
    <div class="modal fade in" id="modal-download">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Download App</h4>
          </div>
          <div class="modal-body" v-if="downloadLink">
            <qrcode style="margin-left:31%" :value="downloadLink" :options="{ width: 200 }"></qrcode>
          </div>
          <div class="modal-body">
            <p class="modal-dialog-shell-p add-agent-choose">
              <a v-on:click="toDownloadLink">{{downloadLink}}</a>
            </p>
          </div>
          <div class="modal-footer">
            <!-- <button type="button" class="btn btn-default pull-left" data-dismiss="modal">关闭</button> -->
            <!-- <button type="button" class="btn btn-primary">保存修改</button> -->
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- download 弹窗 -->
    <!-- log弹窗 -->
    <div class="modal fade in" id="modal-log">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">RealTime LogCat</h4>
          </div>
          <div class="modal-body">
            <p class="modal-dialog-shell-p">{{logDialogCurrentContent}}</p>
          </div>
          <div class="modal-footer"></div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- log弹窗 -->
    <!--弹窗-->
  </section>
</template>
<script>
import api from '../../api'
import utils from '../../utils'
import global from '../Global.vue'
import Vue from 'vue'
import VueWebsocket from 'vue-native-websocket'
import config from '../../config'

const DEVELOP_STAGE = 'S1'
const API_STAGE = 'S2'
const PUBLISH_STAGE = 'S3'

export default {
  name: 'Master',
  data () {
    return {
      newversion_name: '',
      newversion_developlog: '',
      newversion_developshell: '',
      newversion_releaseshell: '',
      newversion_typeid: '',
      newbuild_developlog: '',
      newbuild_developshell: '',
      newbuild_stage: '',
      versionList: [],
      newbuild_robotid: '',
      sendtodevice_robotid: '',
      currentSendToStageid: '',
      currentVersoinPage: 0,
      currentLogContent: {},
      downloadLink: '',
      logDialogCurrentBuildid: '',
      logDialogCurrentContent: '',
      socket: {},
      currentBuildList: {
        'S1': [],
        'S2': [],
        'S3': []
      },
      currentStageBuild: {
        'S1': {
          'result': 1
        },
        'S2': { 'result': 1 },
        'S3': { 'result': 1 }
      },
      macRobotList: [
        {
          name: '',
          id: '',
          task: 0
        }
      ],
      deviceRobotList: [
        {
          name: '',
          id: '',
          task: 0
        }
      ],
      currentVersion: {
        versionname: '-',
        GeneralSetting: {
          StageSupport: []
        }
      },
      shellDialogContent: ''
    }
  },
  computed: {
  },
  created () {
    Vue.use(VueWebsocket, 'wss://testadminapi.dinsafer.com/ws', {
      reconnection: true
    })

    this.socket = Vue.prototype.$socket

    this.socket.onmessage = (data) => this.onMessage(data)
    // VueWebsocket.onconnect = () => console.log('connect')
    this.socket.onopen = (n) => {
      console.log('onopen' + n)
      this.toSendJoinToServer()
    }
    this.socket.onerror = (n) => console.log('onerror' + n)
    this.socket.onclose = (n) => console.log('onclose' + n)
  },
  mounted () {
    this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
    this.toGetVersionList(0)
  },
  beforeDestroy () {
    this.socket.close()
  },
  methods: {
    toShowVersionList () {
      // window.jQuery('#version-list-popmenu').attr('aria-expanded', 'true')
      window.jQuery('#version-list-popmenu').addClass('open')
    },
    toSaveLog () {
      this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
      var params = new URLSearchParams()
      var jsons = {
        appid: this.$route.query.appid,
        typeid: this.$route.query.typeid,
        versionid: this.currentVersion.versionid,
        developlog: window.jQuery('#currentVersionDevelopLog').val(),
        releaselog: window.jQuery('#currentVersionReleaseLog').val()
      }
      params.append('json', utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET))
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token)
      }
      api.requestWithServerUrl('post', config.asServerURI, '/compilation/modifylog?_type=json', params)
        .then(response => {
          this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.Status !== 1) {
          } else {
            this.currentVersion.developlog = window.jQuery('#currentVersionDevelopLog').val()
            this.currentVersion.releaselog = window.jQuery('#currentVersionReleaseLog').val()
          }
        })
    },
    toSendDingDing (stageid) {
      if (this.currentStageBuild[stageid].result !== 1) {
        return
      }
      this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
      var params = new URLSearchParams()
      var jsons = {
        appid: this.$route.query.appid,
        typeid: this.$route.query.typeid,
        versionid: this.currentVersion.versionid,
        stageid: stageid,
        buildid: this.currentStageBuild[stageid].buildid
      }
      params.append('json', utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET))
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token)
      }
      api.requestWithServerUrl('post', config.asServerURI, '/compilation/senddingding?_type=json', params)
        .then(response => {
          this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.Status !== 1) {
          } else {
          }
        })
    },
    toDoSendTo () {
      var params = new URLSearchParams()
      var jsons = {
        appid: this.$route.query.appid,
        versionid: this.currentVersion.versionid,
        buildid: this.currentStageBuild[this.currentSendToStageid].buildid,
        robotid: this.sendtodevice_robotid
      }
      params.append('json', utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET))
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token)
      }
      api.requestWithServerUrl('post', config.asServerURI, '/compilation/sendto?_type=json', params)
        .then(response => {
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.Status !== 1) {
          } else {
            window.jQuery('#sendto_robotlist').modal('hide')
          }
        })
    },
    emptyToInVisibiliy (con, classString) {
      if (!utils.isEmpty(con)) {
        return 'visibiliy ' + classString
      } else {
        return 'invisibiliy'
      }
    },
    isHasBuildList (stageid) {
      if (this.getBuildlistById(stageid) && this.getBuildlistById(stageid).length > 0) {
        return true
      }
      return false
    },
    onMessage (message) {
      var result = JSON.parse(message.data)
      if (result.Cmd && result.Cmd === '/task/taskstate') {
        window.location.reload()
        // for (var key in this.currentBuildList) {
        //   for (let index = 0; index < this.currentBuildList[key].length; index++) {
        //     if (result.Data.buildID === this.currentBuildList[key][index].buildid) {
        //       this.currentBuildList[key][index].resutl = result.Data.state
        //       if (this.currentStageBuild[key].buildid === result.Data.buildID) {
        //         this.currentStageBuild[key].result = result.Data.state
        //       }
        //       return
        //     }
        //   }
        // }
      } else if (result.Cmd && result.Cmd === '/task/sendtasklog') {
        console.log('log result', result.Data)
        if (!this.currentLogContent[result.Data.buildID]) {
          this.currentLogContent[result.Data.buildID] = ''
        }
        var tempContent = this.currentLogContent[result.Data.buildID] + '\r\n' +
          '[' + result.Data.robotid + ']' +
          '[' + result.Data.robotname + '][' + result.Data.Time + ']' +
          '[' + result.Data.Level + '][' + result.Data.Msg + ']'
        Vue.set(this.currentLogContent, result.Data.buildID, tempContent)
        if (this.logDialogCurrentBuildid === result.Data.buildID) {
          this.logDialogCurrentContent = this.currentLogContent[result.Data.buildID]
          console.log('log ', this.currentLogContent[result.Data.buildID])
        }
      }
    },
    selectVersoin (index) {
      this.currentBuildList = {
        'S1': [],
        'S2': [],
        'S3': []
      }
      this.currentStageBuild = {
        'S1': {},
        'S2': {},
        'S3': {}
      }
      this.currentVersion = {
        versionname: '-',
        GeneralSetting: {
          StageSupport: []
        }
      }
      this.toDoAfterSelectVersion(index)
    },
    selectBuild (stageid, index) {
      if (stageid === 'S3') {
        this.$set(this.currentStageBuild, stageid, this.currentBuildList['S2'][index])
      } else {
        this.$set(this.currentStageBuild, stageid, this.currentBuildList[stageid][index])
      }
    },
    toSendJoinToServer () {
      var sd = {
        id: this.$router.app.$store.state.user.uid
      }
      var sf = {
        Cmd: '/task/login',
        Data: sd
      }
      var str = JSON.stringify(sf)
      this.socket.send('iris-websocket-message:join;0;;;' + str)
    },
    toSendMessage (message) {
      // this.socket.send('iris-websocket-message:revice;0;;;' + message)
    },
    toGetLogContent () {
      // console.log('get log')
      // if (this.logDialogCurrentStageid) {
      //   return this.currentLogContent[this.currentStageBuild[this.logDialogCurrentStageid].buildid]
      // }
      // return ''
    },
    toShowLog (stageid) {
      if (this.currentStageBuild[stageid].result === -1) {
        this.logDialogCurrentBuildid = this.currentStageBuild[stageid].buildid
        this.logDialogCurrentContent = ''
        // this.currentLogContent[this.currentStageBuild[stageid].buildid]
        window.jQuery('#modal-log').modal('show')
      } else {
        // 打开日志文件
        var win = window.open(config.asServerURI + '/build/' + this.$route.query.appid +
          '/' + this.currentVersion.versionid + '/' +
          this.currentStageBuild[stageid].buildid + '/logfile.log', '_blank')
        win.focus()
      }
    },
    toShowShell (stageid) {
      this.shellDialogContent = utils.hextoString(this.currentStageBuild[stageid].shell)
      console.log(this.currentStageBuild[stageid])
      window.jQuery('#modal-shell').modal('show')
    },
    toDoPublishClick (stageid) {
      if (this.currentStageBuild[stageid].result !== 1 ||
        this.currentStageBuild[stageid].buildid === this.currentVersion.PublishBuildid) {
        return
      }

      // 点击的buildid和发布的idid不一样，则重新设置buildid和生成下载链接
      this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
      var params = new URLSearchParams()
      var jsons = {
        versionid: this.currentVersion.versionid,
        buildid: this.currentStageBuild[stageid].buildid
      }
      params.append('json', utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET))
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token)
      }
      api.requestWithServerUrl('post', config.asServerURI, '/compilation/modifypublishid?_type=json', params)
        .then(response => {
          this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
          var data = response.data
          if (data.Status !== 1) {
            alert('发布错误')
          } else {
            this.currentVersion.PublishBuildid = this.currentStageBuild[stageid].buildid
          }
        })
    },
    getBtnText (stageid) {
      if (this.currentVersion.PublishBuildid === this.currentStageBuild[stageid].buildid) {
        return '已发布'
      } else {
        return '发布'
      }
    },

    toShowDownload (stageid) {
      if (this.currentStageBuild[stageid].result !== 1) {
        return
      }
      this.currentSendToStageid = stageid
      // var urls = config.asServerURI + '/build/' + this.$route.query.appid + '/' +
      //   this.currentVersion.versionid + '/' +
      //   this.currentStageBuild[this.currentSendToStageid].buildid + '/app-googleplay-release.apk'
      // var urls = 'https://d.din.bz/' + this.currentStageBuild[this.currentSendToStageid].downloadkey
      var urls = this.currentStageBuild[this.currentSendToStageid].downloadkey
      var jsons = {
        app: this.$route.query.appname,
        appid: this.$route.query.appid,
        type: this.$route.query.typeid,
        v: this.currentVersion.versionname,
        b: 'build ' + this.currentStageBuild[this.currentSendToStageid].buildnumber,
        u: urls
      }
      console.log(jsons)
      this.downloadLink = config.asServerURI + '/appdowload?p=' + utils.stringtoHex(JSON.stringify(jsons))
      window.jQuery('#modal-download').modal('show')
    },
    toDownloadLink () {
      var win = window.open(this.downloadLink, '_blank')
      win.focus()
    },
    getBuildlistById (stageid) {
      if (stageid === 'S3') {
        return this.currentBuildList['S2']
      } else {
        return this.currentBuildList[stageid]
      }
    },
    getNameByTypeId (sid) {
      if (sid === DEVELOP_STAGE) {
        return 'TEST'
      }
      if (sid === API_STAGE) {
        return 'API'
      }
      if (sid === PUBLISH_STAGE) {
        return 'PUBLISH'
      }
    },
    getState (result) {
      if (result === -1) {
        return 'Building'
      }
      if (result === 0) {
        return 'Build Failed'
      }
      if (result === 1) {
        return 'Build Succeed'
      }
    },
    isPublishSelectSuccess (stageid, classString) {
      if (!utils.isEmpty(this.currentStageBuild[stageid]) && !utils.isEmpty(this.currentStageBuild[stageid].buildid) &&
        this.currentStageBuild[stageid].result === 1) {
        return 'visibiliy ' + classString
      } else {
        return 'gone ' + classString
      }
    },
    getBuildStageClassByTypeId (result) {
      if (result === -1) {
        return 'fa fa-spinner'
      }
      if (result === 0) {
        return 'fa fa-remove (alias)'
      }
      if (result === 1) {
        return 'fa fa-check'
      }
    },
    getStageClassByTypeId (sid) {
      if (sid === 'S1') {
        return 'box box-warning version-manage-box'
      }
      if (sid === 'S2') {
        return 'box box-info version-manage-box'
      }
      if (sid === 'S3') {
        return 'box box-success version-manage-box'
      }
    },
    getStageLogClassByTypeId (sid) {
      if (sid === 'S1') {
        return 'label label-warning pull-right add-agent-choose'
      }
      if (sid === 'S2') {
        return 'label label-info pull-right add-agent-choose'
      }
      if (sid === 'S3') {
        return 'gone'
      }
    },
    toGetBuildList (versionid, stageid, pages) {
      var params = new URLSearchParams()
      var jsons = {
        appid: this.$route.query.appid,
        typeid: this.$route.query.typeid,
        page: pages,
        stage: stageid,
        versionid: this.currentVersion.versionid
      }
      params.append('json', utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET))
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token)
      }
      api.requestWithServerUrl('post', config.asServerURI, '/compilation/buildlist?_type=json', params)
        .then(response => {
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.Status !== 1) {
          } else {
            var buildlist = JSON.parse(utils.getDecodeRC4Hex(data.Result, global.APP_SECRET))
            buildlist = this.currentBuildList[stageid].concat(buildlist)
            console.log(this.currentBuildList)
            Vue.set(this.currentBuildList, stageid, buildlist)
            if (buildlist.length > 0 && this.currentStageBuild[stageid]) {
              this.currentStageBuild[stageid] = buildlist[0]
              if (stageid === 'S2') {
                this.currentStageBuild['S3'] = buildlist[0]
              }
            }
          }
        })
    },
    toLoadMoreVersion (pages) {
      this.toGetVersionList(pages)
    },
    toLoadMoreBuild (stageid) {
      if (stageid === 'S3') {
        stageid = 'S2'
      }
      if (this.currentBuildList[stageid].length % 5 === 0) {
        this.toGetBuildList(this.currentVersion.versionid, stageid, (this.currentBuildList[stageid].length / 5))
      } else {
        this.toGetBuildList(this.currentVersion.versionid, stageid, (this.currentBuildList[stageid].length / 5) + 1)
      }
    },
    toGetVersionList (pages) {
      var params = new URLSearchParams()
      var jsons = {
        appid: this.$route.query.appid,
        typeid: this.$route.query.typeid,
        page: pages
      }
      params.append('json', utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET))
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token)
      }
      api.requestWithServerUrl('post', config.asServerURI, '/compilation/versionlist?_type=json', params)
        .then(response => {
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.Status !== 1) {
          } else {
            var tempList = JSON.parse(utils.getDecodeRC4Hex(data.Result, global.APP_SECRET))
            if (pages === 0) {
              this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
            }
            if (tempList.length > 0 && this.currentVersion.versionname === '-') {
              this.versionList = tempList
              this.currentVersoinPage++
              this.toDoAfterSelectVersion(0)
            } else {
              this.currentVersoinPage++
              this.versionList = this.versionList.concat(tempList)
              // this.toShowVersionList()
            }
          }
        })
    },
    toDoAfterSelectVersion (index) {
      this.currentVersion = this.versionList[index]
      console.log(this.currentVersion)

      for (var i = 0; i < this.currentVersion.GeneralSetting.StageSupport.length; i++) {
        this.toGetBuildList(this.currentVersion.versionid,
          this.currentVersion.GeneralSetting.StageSupport[i], 0)
      }
    },
    toNewBuild (item) {
      if (!utils.isEmpty(this.currentVersion.PublishBuildid)) {
        alert('已经发布了，不能再新建Build')
        return
      }
      // TODO 获取机器人列表以及默认的shell配置
      if (item === DEVELOP_STAGE) {
        this.newbuild_developshell = utils.hextoString(this.currentVersion.DevelopShell)
      } else if (item === API_STAGE) {
        this.newbuild_developshell = utils.hextoString(this.currentVersion.ReleaseShell)
      }

      this.newbuild_stage = item

      this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
      var params = new URLSearchParams()
      var jsons = {
        _lindex: 0,
        _limit: 0,
        isonline: 1
      }
      params.append('json', utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET))
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token)
      }
      api.requestWithServerUrl('post', config.asServerURI, '/compilation/robotlist?_type=json', params)
        .then(response => {
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.Status !== 1) {
            this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
          } else {
            if (data.Result) {
              this.macRobotList = []
              var robotlist = JSON.parse(utils.getDecodeRC4Hex(data.Result, global.APP_SECRET))
              for (var i = 0; i < robotlist.length; i++) {
                if (robotlist[i].type === global.MAC_TYPE) {
                  this.macRobotList.push(robotlist[i])
                }
              }
              this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
              window.jQuery('#modal-new-build').modal('show')
            }
          }
        })
    },
    toDoNewBuild () {
      var tempShell = utils.stringtoHex(this.newbuild_developshell)
      if (tempShell === this.currentVersion.DevelopShell) {
        tempShell = ''
      }

      this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
      var params = new URLSearchParams()
      var jsons = {
        appid: this.$route.query.appid,
        typeid: this.currentVersion.Type.id,
        versionid: this.currentVersion.versionid,
        stage: this.newbuild_stage,
        robotid: this.newbuild_robotid,
        comment: this.newbuild_developlog,
        shell: tempShell
      }
      params.append('json', utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET))
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token)
      }
      api.requestWithServerUrl('post', config.asServerURI, '/compilation/newbuild?_type=json', params)
        .then(response => {
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.Status !== 1) {
            this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
          } else {
            this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
            window.location.reload()
          }
        })
    },
    toNewVersion () {
      this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
      var params = new URLSearchParams()
      var jsons = {
        appid: this.$route.query.appid,
        typeid: this.$route.query.typeid
      }
      params.append('json', utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET))
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token)
      }
      api.requestWithServerUrl('post', config.asServerURI, '/compilation/getshell?_type=json', params)
        .then(response => {
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.Status !== 1) {
            this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
            alert('获取默认脚本错误')
          } else {
            var tempResult = JSON.parse(utils.getDecodeRC4Hex(data.Result, global.APP_SECRET))
            this.newversion_developshell = utils.hextoString(tempResult.testShell)
            this.newversion_releaseshell = utils.hextoString(tempResult.apiShell)
            this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
            window.jQuery('#modal-new-version').modal('show')
          }
        })
    },
    toDoNewVersion () {
      var params = new URLSearchParams()
      var tempDevelopShell = utils.stringtoHex(this.newversion_developshell)
      var tempReleaseShell = utils.stringtoHex(this.newversion_releaseshell)
      var jsons = {
        appid: this.$route.query.appid,
        versionname: this.newversion_name,
        developlog: this.newversion_developlog,
        developshell: tempDevelopShell,
        releaseshell: tempReleaseShell,
        typeid: this.$route.query.typeid
      }
      params.append('json', utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET))
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token)
      }
      api.requestWithServerUrl('post', config.asServerURI, '/compilation/newversion?_type=json', params)
        .then(response => {
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.Status !== 1) {
          } else {
            window.location.reload()
          }
        })
    }
  },
  filters: {
    formatDate (time) {
      var date = new Date(time)
      return utils.formatDate(date, 'yyyy-MM-dd hh:mm')
    }
  }
}

</script>
<style>
</style>



// WEBPACK FOOTER //
// Ios.vue?cec9a448